import { createSlice } from '@reduxjs/toolkit';
import type { TRootState } from 'slices/store';
import { createAppAsyncThunk } from 'slices/utils';
import {
  finishedLoadingFailure,
  finishedLoadingSuccess,
  isLoadingRequest,
} from 'utils/sliceHelpers';
import type { ITEReportingEnabledDataSources } from '@timeedit/types';
import api from '../services/api.service';

type TAppsReportSourceTypeState = {
  loading: boolean;
  hasErrors: boolean;
  dataSource: TDataSource;
};

type TDataSource = Partial<ITEReportingEnabledDataSources>;

export const initialState: TAppsReportSourceTypeState = {
  loading: false,
  hasErrors: false,
  dataSource: {},
};

const slice = createSlice({
  name: 'appsReportSourceType',
  initialState,
  reducers: {
    fetchData: (state) => {
      isLoadingRequest(state);
    },
    fetchDataSuccess: (state, { payload }) => {
      state.dataSource = payload;
      finishedLoadingSuccess(state);
    },
    fetchDataFailure: (state) => {
      finishedLoadingFailure(state);
    },
  },
});

export default slice.reducer;

// Selectors
export const reportSourceTypeLoading = (state: TRootState) =>
  state.appsReportSourceType.loading;
export const reportSourceTypeDataSource = (state: TRootState) =>
  state.appsReportSourceType.dataSource;

// Actions
export const { fetchData, fetchDataSuccess, fetchDataFailure } = slice.actions;

export const getDataSource = createAppAsyncThunk(
  'appsReportSourceType/getDataSource',
  async (_, { dispatch }) => {
    try {
      dispatch(fetchData());
      const data = (await api.get({
        endpoint: '/apps/TE_REPORTING/data-sources',
      })) as TDataSource;
      dispatch(fetchDataSuccess(data));
    } catch (e) {
      dispatch(fetchDataFailure());
      return console.error(e);
    }
  }
);

export const updateDataSource = createAppAsyncThunk<void, TDataSource>(
  'appsReportSourceType/updateDataSource',
  async (data, { dispatch }) => {
    try {
      await api.patch({
        endpoint: '/apps/TE_REPORTING/data-sources',
        data,
      });
      dispatch(getDataSource());
    } catch (e) {
      dispatch(fetchDataFailure());
      return console.error(e);
    }
  }
);
